import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaSeedling } from "react-icons/fa6";
import { SiFiles } from "react-icons/si";
import { ReactNode, useEffect, useState } from "react";
import { SiSendinblue } from "react-icons/si";
import { MdHomeFilled, MdConnectWithoutContact, MdOutlineAnalytics, MdManageHistory } from "react-icons/md";
import { HiDocumentPlus } from "react-icons/hi2";
import { IoPersonAdd } from "react-icons/io5";
import { getId, checkIsAdmin } from "../../api/axiosApi";
import { BiSlider } from "react-icons/bi";

export interface SideBarIconProps {
    icon: ReactNode;
    text: string;
    to: string;
    response?: string;
    conversation_id?: string;
}

export const SideBarIcon = ({ icon, text, to }: SideBarIconProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const Id = useParams();
    const arr = to.split(" ");
    let isActive = false;
    if (location.pathname.includes(arr[0]) || location.pathname.includes("/" + arr[1])) {
        isActive = true;
    }
    if (location.pathname === `/caselets/${Id.id}`) {
        isActive = false;
    }
    const handleClick = async () => {
        // if (to === "/interaction") {
        //     try {
        //         const idResponse = await getId();
        //         // if (idResponse.status === 401 || idResponse.status === 422) {
        //         //     navigate("/user_login");
        //         // }
        //         // if (!idResponse.ok) {
        //         //     throw new Error(`Failed to fetch ID: ${idResponse.status}`);
        //         // }
        //         // const id = await idResponse.json();
        //         const id = await idResponse.data;

        //         navigate(`/interaction/${id.Id}`, { state: { from: "new" } });
        //     } catch (error) {
        //         console.error("Failed to fetch ID and navigate", error);
        //     }
        // } else
        if (to === "/workbench") {
            navigate(to || "/workbench");
        } else if (to === "/my-exclusive-content") {
            navigate(to);
        } else if (to === "/citation-explorer") {
            navigate(to || "/citation-explorer", { state: { from: "listSeed" } });
        } else if (to === "/caselets" && !isActive) {
            navigate(to || "/caselets");
        } else if (to === "/engagement") {
            navigate(to || "/engagement");
        } else if (to === "/participants") {
            navigate(to || "/participants");
        } else if (to === "/analytics") {
            navigate(to || "/analytics");
        } else if (to === "/source-weights") {
            navigate(to || "/source-weights");
        } else if (to === "/content-upload") {
            navigate(to || "/content-upload");
        }
    };
    return (
        <div onClick={handleClick} className={`sidebar-icon group ${isActive ? "activeSideNav" : ""}`}>
            {icon}
            <span className="sidebar-tooltip group-hover:scale-100">{text}</span>
        </div>
    );
};

const SideBar = () => {
    const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const res = await checkIsAdmin();
                if (res.data.is_super_admin === true) {
                    setIsSuperAdmin(true);
                }
            } catch (error) {
                console.error("Error checking super admin status:", error);
                setIsSuperAdmin(false);
            }
        };
        checkAdminStatus();
    }, []);

    return (
        <div
            className="fixed top-16 left-0 w-16 flex flex-col justify-between
                bg-white shadow-lg sidebar-height z-10"
        >
            <div>
                <SideBarIcon icon={<MdHomeFilled size="28" />} text={"Workbench"} to="/workbench" />
                <SideBarIcon icon={<HiDocumentPlus size="28" />} text={"My Exclusive content"} to="/my-exclusive-content" />
                {/* <SideBarIcon icon={<SiSendinblue size="28" />} text={"Interaction"} to="/interaction" /> */}
                <SideBarIcon icon={<FaSeedling size="28" />} text={"Prefetch Citation Explorer"} to="/citation-explorer" />
                {/* <SideBarIcon icon={<SiFiles size="28" />} text={"Published Caselets"} to="/caselets" /> */}
                {/* <SideBarIcon icon={<MdConnectWithoutContact size="28" />} text={"Engagement"} to="/engagement" /> */}
                <SideBarIcon icon={<IoPersonAdd size="28" />} text={"Add Participant"} to="/participants" />
                <SideBarIcon icon={<MdOutlineAnalytics size="28" />} text={"Analytics"} to="/analytics" />
                <SideBarIcon icon={<BiSlider size="28" />} text={"Source Weights"} to="/source-weights" />
                {isSuperAdmin && <SideBarIcon icon={<MdManageHistory size="28" />} text={"Manage Content"} to="/content-upload" />}
            </div>
        </div>
    );
};

export default SideBar;
